module.exports = __webpack_public_path__ + "img/bg_circle.8d54e41.png";